import { Link } from "react-router-dom";
import Layout from "./Layout";
import SEOHead from "./SEOHead";
import Breadcrumb from "./Breadcrumb";
import { states, locations } from "../data/locations";
import { industries } from "../data/industries";
import { blogPosts } from "../data/blogPosts";
import { newServices } from "../data/newServices";
import { blogCategories } from "../data/blogCategories";

const LinkColumn = ({ title, links }) => (
  <div>
    <h2 className="font-montserrat text-lg font-bold text-foreground mb-4">{title}</h2>
    <ul className="space-y-2">
      {links.map((l) => (
        <li key={l.path}>
          <Link to={l.path} className="text-muted-foreground hover:text-primary transition text-sm">
            {l.name}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const SiteMap = () => {
  const mainPages = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Quality", path: "/quality" },
    { name: "Contact", path: "/contact" },
    { name: "Gallery", path: "/gallery" },
    { name: "Projects", path: "/projects" },
    { name: "Brochure", path: "/brochure" },
    { name: "Enquiry", path: "/enquiry" },
    { name: "PEB Cost Calculator", path: "/peb-cost-calculator" },
    { name: "FAQ", path: "/faq" },
  ];

  const services = [
    { name: "Prefabricated Buildings", path: "/pre-fab-structure-buildings" },
    { name: "Structural Steel Fabrication", path: "/structure-steel-fabrication" },
    { name: "Roof & Wall Sheeting", path: "/roof-wall-sheeting" },
    { name: "Industrial Sheds", path: "/industrial-sheds" },
    { name: "Industrial Structures", path: "/IndustrialStructures" },
    { name: "Fabrication Services", path: "/FabricationServices" },
    ...newServices.map((s) => ({ name: s.name, path: s.path })),
  ];

  const industryLinks = [
    { name: "All Industries", path: "/industries" },
    ...industries.map((i) => ({ name: i.name, path: `/industries/${i.slug}` })),
  ];

  const locationLinks = [
    { name: "All Locations", path: "/locations" },
    ...states.map((s) => ({ name: s.name, path: `/locations/${s.slug}` })),
    ...locations.map((l) => ({ name: `${l.name}, ${l.stateSlug === "telangana" ? "Telangana" : "Andhra Pradesh"}`, path: `/locations/${l.stateSlug}/${l.slug}` })),
  ];

  return (
    <Layout>
      <SEOHead
        title="Sitemap | Vasavi Structures"
        description="Full site map of Vasavi Structures' pages — services, industries, locations and resources across Telangana and Andhra Pradesh."
      />
      <Breadcrumb items={[{ name: "Sitemap" }]} />

      <section className="section-padding">
        <div className="container-custom">
          <h1 className="font-montserrat text-3xl md:text-4xl font-bold text-foreground mb-10">
            Site <span className="text-secondary">Map</span>
          </h1>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
            <LinkColumn title="Main Pages" links={mainPages} />
            <LinkColumn title="Services" links={services} />
            <LinkColumn title="Industries" links={industryLinks} />
            <LinkColumn title="Locations" links={locationLinks} />
          </div>

          <h2 className="font-montserrat text-2xl font-bold text-foreground mb-6">Resources & Guides</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {blogCategories.map((cat) => (
              <LinkColumn
                key={cat.id}
                title={cat.name}
                links={blogPosts
                  .filter((p) => p.category === cat.id)
                  .map((p) => ({ name: p.title, path: `/resources/${p.slug}` }))}
              />
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default SiteMap;
